import { useEffect } from "react";
import { Modal, Form, Input } from "antd";

export const MultipleInputFieldModal = ({ propsData }) => {
  const { title, data, open, onCancel, onOk, okText, formItems, form } =
    propsData;

  useEffect(() => {
    if (open && data) {
      form.setFieldsValue(data);
    } else {
      form.resetFields();
    }
  }, [open, data, form]);

  const renderFormItem = (item) => {
    const placeholderText = item?.placeholder || `Enter ${item.label}`;

    switch (item.type) {
      case "password":
        return <Input.Password placeholder={placeholderText} />;
      default:
        return <Input placeholder={placeholderText} />;
    }
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      onOk={() => form.submit()}
      okText={okText}
    >
      <Form form={form} layout="vertical" onFinish={onOk}>
        {formItems.map((item) => (
          <Form.Item
            key={item.name}
            name={item.name}
            label={item.label}
            rules={item.rules}
          >
            {renderFormItem(item)}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
